import React, {useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Corporate.css';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';

function Corporate() {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // This will make it jump to the top without smooth scrolling
    });
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Corporate Page' });
  }, []);
  return (
<div>
  <Helmet>
        <meta charSet="utf-8" />
        <title>Corporate</title>
  </Helmet>
  <div className="blog-container">
    <h1 className="blog-header">Welcome to our Corporate Green Tree Planting Program!</h1>
    <p className="blog-text">At Blue Plant Ecosystem, we believe in creating a greener, more sustainable future for the
      planet. With our environmentally friendly tree planting program, corporate partners now have an effective
      means to engage their workers in a meaningful way with tools that positively impact the environment.
    </p>
    <img src="/img/img/corporate.jpg" alt="" className="blog-img" />
    <h2 className="blog-highlight">Our Program Highlights:</h2>
    <div className="blog-section">
      <h5>Get a Free Tree for Every Employee:
      </h5>
      <p className="blog-text">As part of our commitment to sustainability, we provide a complimentary tree for every
        employee in your organization. This not only encourages a sense of responsibility towards the
        environment but also fosters a sense of teamwork and camaraderie among your workforce.
      </p>
    </div>
    <p className="blog-text" style={{color: 'green'}}>
    </p><h5>Affordable Additional Trees:
    </h5>
    <p className="blog-text" style={{color: 'green'}}>We understand the importance of scalability in environmental
      initiatives. For each additional tree planted beyond the initial complimentary tree, we charge only $1. This
      nominal fee makes it easy for your organization to participate and plant as many trees as you wish. We also
      offer programs for each corporate partner to match their employees.
    </p>
    <h5> Customization Options:
    </h5>
    <p className="blog-text" style={{color: 'green'}}>Choose from a wide variety of tree species to
      suit your preferences and the environment in your area. Whether you want
      fruit-bearing trees, flowering trees, or those that attract local
      wildlife, we've got you covered.
    </p>
    <h5> Track Your Impact:</h5>
    <p className="blog-text" style={{color: 'green'}}> We offer a wide variety of tree species to choose from, ensuring that
      you can select the ones that best align with your corporate values and geographical location. You can also
      choose to plant trees in specific regions, supporting local ecosystems and communities.
    </p>
    <h5>Tree Tracking and Impact Reports:
    </h5>
    <p className="blog-text" style={{color: 'green'}}>Transparency is essential, and we provide regular updates on the
      growth and impact of the trees planted through our program. Your organization will receive detailed reports
      showcasing the positive environmental effects of your contributions. Each employee that signs up receives a
      login to track both the corporate progress and the employee's individual contributions and progress.
    </p>
    <h5>Corporate Social Responsibility (CSR) Boost:
    </h5>
    <p className="blog-text" style={{color: 'green'}}> Engaging in sustainability initiatives like tree planting can
      significantly enhance your company's CSR profile. Demonstrate your commitment to the environment and inspire
      others in your industry to follow suit.
    </p>
    <h5>Employee Engagement and Wellbeing:
    </h5>
    <p className="blog-text" style={{color: 'green'}}>Encourage your employees to take part in tree planting events and
      foster a sense of pride in contributing to a greener world. Engaging in outdoor activities and spending time
      in nature has proven benefits for employee wellbeing and productivity.
    </p>
    <h5>Green Marketing Opportunities:
    </h5>
    <p className="blog-text" style={{color: 'green'}}>By participating in our Corporate Green Tree Planting Program, your
      organization gains an excellent green marketing angle that resonates with environmentally conscious
      customers and stakeholders.
    </p>
    <p className="blog-text" style={{color: 'green'}}>
      Join us in making a difference today! Let's create a lasting impact on the environment together through our
      Corporate Green Tree Planting Program. Contact us now to get started on this sustainable journey towards a
      healthier planet.
    </p>
  </div>
  <Link className="btn btn-primary btn-lg" to="/site/about" id='btn-signup'>Learn More</Link>

  {/* Back to Top */}
  <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>
</div>

  );
}

export default Corporate;